/**
 * Tensie body-cover PDP — shades, bundles, sticky, BA slider, ATC.
 */
function readData() {
  const el = document.getElementById('body-cover-product-data');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function formatMoney(cents, format, currency) {
  const amount = (Number(cents) / 100).toFixed(2);
  const withComma = amount.replace('.', ',');
  const withSpace = withComma.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const fmt = format || '{{amount_with_space_separator}} kr';
  return fmt
    .replace('{{amount_with_space_separator}}', withSpace)
    .replace('{{amount_with_comma_separator}}', withComma)
    .replace('{{amount}}', amount)
    .replace('{{currency}}', currency || 'SEK');
}

function init() {
  const data = readData();
  const priceEl = document.getElementById('mainPrice');
  if (!priceEl || !data) return;

  const moneyFormat = priceEl.dataset.moneyFormat;
  const currency = priceEl.dataset.currency || 'SEK';
  const money = (c) => formatMoney(c, moneyFormat, currency);

  let shade = data.shades?.[1]?.name || data.shades?.[0]?.name || 'Light';
  let qty = 2;

  const variantInput = document.getElementById('bc-variant-id');
  const qtyInput = document.getElementById('bc-quantity');
  const shadeDot = document.getElementById('shadeDot');
  const shadeName = document.getElementById('shadeName');
  const stageMedia = document.getElementById('bcStageMedia');

  function findVariant(shadeName) {
    return data.variants.find((v) => v.shade === shadeName) || data.variants[0];
  }

  function bundleTotal(q, unit) {
    const pairOff = data.discounts?.pairOff ?? 10000;
    const trioOff = data.discounts?.trioOff ?? 24000;
    if (q === 2) return unit * 2 - pairOff;
    if (q === 3) return unit * 3 - trioOff;
    return unit * q;
  }

  function updatePrices() {
    const v = findVariant(shade);
    if (!v) return;
    const unit = v.price;
    const compare = v.compare > v.price ? v.compare : Math.round(unit * (429 / 329));
    const now = bundleTotal(qty, unit);
    const was = compare * qty;
    const save = was - now;

    document.getElementById('mainPrice').textContent = money(now);
    const cmp = document.getElementById('mainCompare');
    const pill = document.getElementById('savePill');
    if (cmp) {
      cmp.textContent = money(was);
      cmp.hidden = save <= 0;
    }
    if (pill) {
      pill.textContent = `${priceEl.dataset.saveLabel || 'Du sparar'} ${money(save)}`;
      pill.hidden = save <= 0;
    }
    const atc = document.getElementById('atcPrice');
    if (atc) atc.textContent = money(now);
    const stickyPrice = document.getElementById('stickyPrice');
    const stickyLabel = document.getElementById('stickyLabel');
    if (stickyPrice) stickyPrice.textContent = money(now);
    if (stickyLabel) stickyLabel.textContent = `${qty} ${qty === 1 ? 'tub' : 'tuber'} · ${shade}`;

    if (variantInput) variantInput.value = String(v.id);
    if (qtyInput) qtyInput.value = String(qty);

    document.querySelectorAll('#bcBundles .bundle').forEach((btn) => {
      const q = Number(btn.dataset.qty);
      const n = bundleTotal(q, unit);
      const w = compare * q;
      btn.dataset.nowCents = String(n);
      btn.dataset.wasCents = String(w);
      const priceNode = btn.querySelector('.b-price');
      if (priceNode) {
        const wasEl = priceNode.querySelector('.b-was');
        const nowEl = priceNode.querySelector('[data-now]');
        if (wasEl) {
          wasEl.textContent = money(w);
          wasEl.hidden = w <= n;
        }
        if (nowEl) nowEl.textContent = money(n);
      }
    });
  }

  function ensureMainImg() {
    let img = document.getElementById('mainImg');
    if (!img && stageMedia) {
      img = document.createElement('img');
      img.id = 'mainImg';
      img.className = 'bc-main-img';
      stageMedia.appendChild(img);
    }
    return img;
  }

  function showStageImage(url) {
    if (!stageMedia || !url) return;
    stageMedia.querySelectorAll('video, .bc-main-video').forEach((v) => v.remove());
    const img = ensureMainImg();
    if (!img) return;
    img.hidden = false;
    img.src = url;
    img.removeAttribute('srcset');
  }

  function showStageVideo(url, poster) {
    if (!stageMedia || !url) return;
    const img = document.getElementById('mainImg');
    if (img) img.hidden = true;
    stageMedia.querySelectorAll('video, .bc-main-video').forEach((v) => v.remove());
    const video = document.createElement('video');
    video.id = 'mainVideo';
    video.className = 'bc-main-video';
    video.src = url;
    if (poster) video.poster = poster;
    video.controls = true;
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    stageMedia.appendChild(video);
    video.play().catch(() => {});
  }

  function setShade(name, hex, mediaUrl) {
    shade = name;
    document.querySelectorAll('#bcShades .shade').forEach((s) => {
      s.classList.toggle('active', s.dataset.name === name);
    });
    if (shadeDot && hex) shadeDot.style.background = hex;
    if (shadeName) shadeName.textContent = `Nyans · ${name}`;
    if (mediaUrl) showStageImage(mediaUrl);
    updatePrices();
  }

  document.querySelectorAll('#bcShades .shade').forEach((btn) => {
    btn.addEventListener('click', () => {
      const s = data.shades.find((x) => x.name === btn.dataset.name);
      setShade(btn.dataset.name, s?.hex || getComputedStyle(btn).backgroundColor, s?.mediaUrl);
    });
  });

  document.querySelectorAll('#bcBundles .bundle').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('#bcBundles .bundle').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      qty = Number(btn.dataset.qty) || 1;
      updatePrices();
    });
  });

  document.querySelectorAll('#bcThumbs button').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('#bcThumbs button').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      if (btn.dataset.type === 'video' && btn.dataset.videoSrc) {
        showStageVideo(btn.dataset.videoSrc, btn.dataset.poster);
      } else if (btn.dataset.src) {
        showStageImage(btn.dataset.src);
      }
    });
  });

  // sticky
  const sticky = document.getElementById('stickyAtc');
  const buy = document.getElementById('buy');
  if (sticky && buy) {
    const io = new IntersectionObserver(
      ([e]) => {
        sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    io.observe(buy);
  }
  document.getElementById('stickyBtn')?.addEventListener('click', () => {
    document.getElementById('bc-product-form')?.requestSubmit?.() ||
      document.getElementById('bcAtc')?.click();
  });

  // accordions
  function wire(itemSel, headSel, bodySel) {
    document.querySelectorAll(itemSel).forEach((item) => {
      const head = item.querySelector(headSel);
      const body = item.querySelector(bodySel);
      if (!head || !body) return;
      head.addEventListener('click', () => {
        const open = item.classList.toggle('open');
        body.style.maxHeight = open ? `${body.scrollHeight}px` : '0';
      });
    });
  }
  wire('.acc-item', '.acc-head', '.acc-body');
  wire('.faq-item', '.faq-q', '.faq-a');

  // before/after
  const ba = document.getElementById('ba');
  if (ba) {
    let dragging = false;
    const setPos = (clientX) => {
      const r = ba.getBoundingClientRect();
      let pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      ba.style.setProperty('--pos', `${pct}%`);
      document.getElementById('baBefore')?.style.setProperty('--pos', `${pct}%`);
      const handle = document.getElementById('baHandle');
      if (handle) handle.style.left = `${pct}%`;
    };
    ba.addEventListener('pointerdown', (e) => {
      dragging = true;
      setPos(e.clientX);
      ba.setPointerCapture(e.pointerId);
    });
    ba.addEventListener('pointermove', (e) => {
      if (dragging) setPos(e.clientX);
    });
    ba.addEventListener('pointerup', () => {
      dragging = false;
    });
  }

  // init shade from first selected / Light
  const initial =
    data.shades.find((s) => s.name === shade) ||
    data.shades.find((s) => s.name === 'Light') ||
    data.shades[0];
  if (initial) setShade(initial.name, initial.hex, initial.mediaUrl);
  else updatePrices();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
